import { dashboardAPI } from "@/services";

const SESSION_LOCAL_STORAGE_KEYS = [
  "accessToken",
  "accessUser",
  "setSelectedEventId",
  "setSelectedStallholderId",
  "setSelectedTab",
  "setEventObj",
  "setStallObj",
  "setStallHolderselectObj",
  "setStallselectObj",
  "setTerminalObj",
  "setNewObj",
  "setDeviceObj",
  "setStallholderObj",
];

export default {
  async logout({ commit }) {
    try {
      SESSION_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));

      dashboardAPI.clearHeaders();

      // Reset all Vuex store modules so the next login never paints prior-user data
      commit("resetAppState");
      commit("dashboard/resetDashboardState", null, { root: true });
      commit("filter/resetFilterState", null, { root: true });
      commit("admin/resetAdminState", null, { root: true });

      return Promise.resolve();
    } catch (error) {
      console.error("Error during logout cleanup:", error);
      return Promise.reject(error);
    }
  },
};
